import { LoadingButton } from '@mui/lab';
import { styled, Typography } from '@mui/material';

export const StyledButtonAction = styled(LoadingButton)`
  background: #9dd049;
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  padding: 4.5px 15.5px;
  height: fit-content;
  border-radius: 5px;
`;

export const StyledTypography = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
`;

export const StyledTypoNoAction = styled(StyledTypography)`
  color: #a3a7b0;
`;
